import { HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { SERVICE_ENDPOINTS } from '../../core/configs/service-endpoints';
import { ServiceResult } from '../../core/interfaces/service-result';
import { AuthService } from '../../core/services/auth.service';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { PaymentPageDataCreate } from '../dtos/payment-page/payment-page-data-create';
import { PaymentPageData } from '../interfaces/payment-page/payment-page-data';

@Injectable({
  providedIn: 'root'
})
export class PaymentPageService extends BaseCrudService<PaymentPageDataCreate, PaymentPageData>{

  baseUrl = this.runtimeConfig.dataBackend;
  authService = inject(AuthService);

  constructor() {
    super();
  }


  /**
   * get payment pages, with LazyLoading-Params (paging), for a specific organisation
   * @param lazyLoadEvent
   */
  findPage(lazyLoadEvent: LazyLoadEvent): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + SERVICE_ENDPOINTS.GET_PAYMENT_PAGE, {headers, params});
  }

}
